import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PhotographerRoutingModule } from './photographer-routing.module';
import { UploadImagesForApprovalComponent } from './components/upload-images-for-approval/upload-images-for-approval.component';
import { SharedModule } from '../shared/shared.module';
import { FileUploadModule } from 'ng2-file-upload';
import { DashboardComponent } from './dashboard.component';
import { ImagesHistoryComponent } from './components/images-history/images-history.component';
import { PhotographerImageService } from './services/photographer-image.service';
import { PhotographerProfileService } from './services/profile.service';
import { PhotographerProfileComponent } from '../photographer/components/profile/profile.component';
import { ZohoBookService } from './services/zoho.book.service';
import { ZohoBookBillListComponent, ZohoBookDetailComponent } from './components/zoho-book';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PaymentLogComponent } from './components/payment-log/payment.log.component';
import { PaymentService } from './services/payment.service';
import { StripeAccountErrorComponent } from './components/stripe-account-error/stripe.account.error.component';

@NgModule({
  declarations: [
    DashboardComponent,
    UploadImagesForApprovalComponent,
    ImagesHistoryComponent,
    PhotographerProfileComponent,
    ZohoBookBillListComponent,
    ZohoBookDetailComponent,
    PaymentLogComponent,
    StripeAccountErrorComponent
  ],
  imports: [
    CommonModule,
    PhotographerRoutingModule,
    FileUploadModule,
    SharedModule,
    NgbModule
  ],
  entryComponents: [
    StripeAccountErrorComponent
  ],
  providers: [
    PhotographerImageService,
    PhotographerProfileService,
    ZohoBookService,
    PaymentService
  ]
})
export class PhotographerModule { }
